export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "total_number_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productores"])},
          "producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor"])},
          "expired_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vencido"])},
          "days": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["En ", _interpolate(_named("days")), " días"])},
          "download_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar"])}
        }
      },
      "en": {
        "labels": {
          "total_number_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producers"])},
          "producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producer"])},
          "expired_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expired"])},
          "days": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["days"])},
          "download_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download"])}
        }
      }
    }
  })
}